import { useMutation } from '@tanstack/react-query';
import FileSaver from 'file-saver';

import { backAlertMessage } from 'hooks/utils/backAlertMessage';
import { extractFileNameFromContentDisposition } from 'utils/requestUtils';

const useDownloadFile = <T,>(
  defaultFileName: string,
  callback: (args: T) => Promise<Response>,
  showToasterOnError = true,
  errorHandler?: (error: Response) => Promise<void>,
  successHandler?: (response: Response) => Promise<void>,
) => {
  return useMutation({
    mutationFn: async (args: T) => {
      return callback(args)
        .then(async response => {
          const fileName =
            extractFileNameFromContentDisposition(response) || defaultFileName;
          FileSaver.saveAs(await response.blob(), fileName);
          if (successHandler) {
            return successHandler(response);
          }
        })
        .catch((error: Response) => {
          if (showToasterOnError) {
            void backAlertMessage(error);
          }
          if (errorHandler) {
            return errorHandler(error);
          }
        });
    },
  });
};

export default useDownloadFile;
